import React, { useState } from "react";
import { useSocialAccounts, useUnlinkSocialAccount, useInitiateSocialLink } from "@/api/hooks";

const PROVIDERS = [
  { key: "twitter", label: "Twitter / X", icon: "𝕏", color: "#000" },
  { key: "linkedin", label: "LinkedIn", icon: "in", color: "#0A66C2" },
  { key: "facebook", label: "Facebook", icon: "f", color: "#1877F2" },
  { key: "discord", label: "Discord", icon: "🎮", color: "#5865F2" },
];

export default function ConnectedAccounts() {
  const { data, isLoading } = useSocialAccounts();
  const unlinkMutation = useUnlinkSocialAccount();
  const { initiate } = useInitiateSocialLink();
  const [linking, setLinking] = useState(null); // provider key while in progress
  const [error, setError] = useState(null);

  if (isLoading) return null;

  const linked = data?.social_accounts || [];
  const linkedMap = Object.fromEntries(linked.map((a) => [a.provider, a]));

  const handleConnect = async (provider) => {
    setLinking(provider);
    setError(null);
    try {
      await initiate(provider);
    } catch (err) {
      if (err.message !== 'cancelled') {
        setError(err.message);
      }
    } finally {
      setLinking(null);
    }
  };

  return (
    <div className="mt-8">
      <p className="text-xs font-black uppercase tracking-widest mb-4" style={{ color: "#c8f135" }}>
        חשבונות מקושרים
      </p>

      {error && (
        <div
          className="rounded-lg px-3 py-2 mb-3 text-xs font-bold"
          style={{ background: "rgba(239,68,68,0.15)", color: "#ef4444" }}
        >
          {error}
        </div>
      )}

      <div className="space-y-3">
        {PROVIDERS.map((p) => {
          const account = linkedMap[p.key];
          const isLinking = linking === p.key;

          return (
            <div
              key={p.key}
              className="rounded-2xl p-4 flex items-center justify-between"
              style={{ background: "#111", border: "1px solid #222" }}
            >
              <div className="flex items-center gap-3">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm"
                  style={{ background: p.color }}
                >
                  {p.icon}
                </div>
                <div>
                  <p className="font-bold text-white text-sm">{p.label}</p>
                  {account ? (
                    <p className="text-xs" style={{ color: "rgba(255,255,255,0.5)" }}>
                      {account.username || account.provider_user_id}
                    </p>
                  ) : (
                    <p className="text-xs" style={{ color: "rgba(255,255,255,0.3)" }}>
                      לא מקושר
                    </p>
                  )}
                </div>
              </div>

              {account ? (
                <button
                  onClick={() => unlinkMutation.mutate(p.key)}
                  disabled={unlinkMutation.isPending}
                  className="px-3 py-1.5 rounded-lg text-xs font-bold transition-all"
                  style={{ background: "rgba(239,68,68,0.15)", color: "#ef4444" }}
                >
                  נתק
                </button>
              ) : (
                <button
                  onClick={() => handleConnect(p.key)}
                  disabled={isLinking}
                  className="px-3 py-1.5 rounded-lg text-xs font-bold transition-all"
                  style={{
                    background: isLinking ? "rgba(200,241,53,0.1)" : "rgba(200,241,53,0.15)",
                    color: "#c8f135",
                  }}
                >
                  {isLinking ? "מתחבר..." : "חבר"}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
